import { render, staticRenderFns } from "./LForm.vue?vue&type=template&id=4d814f92"
import script from "./LForm.vue?vue&type=script&lang=ts"
export * from "./LForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports